import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import PublicLayout from "@/components/PublicLayout";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

export default function Activar() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { login } = useAuth();
  const [form, setForm] = useState({ code: params.get("code") || "", email: "", full_name: "", password: "" });
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const { data } = await api.post("/public/activate", {
        code: form.code.toUpperCase(), email: form.email,
        full_name: form.full_name, password: form.password,
      });
      login(data);
      toast.success(`¡Bienvenido! Acceso a ${data.program.title}`);
      nav("/app/alumno");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setSubmitting(false); }
  };

  return (
    <PublicLayout>
      <section className="max-w-lg mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="text-center">
          <div className="mx-auto w-12 h-12 rounded-md bg-[#F26A21]/20 border border-[#F26A21]/40 flex items-center justify-center">
            <KeyRound className="w-6 h-6 text-[#F26A21]" />
          </div>
          <h1 className="mt-4 text-3xl sm:text-4xl font-bold text-[#0B0B0B] font-display">Activa tu beneficio</h1>
          <p className="mt-2 text-[#0B0B0B]">Ingresa el código proporcionado por tu institución.</p>
        </div>
        <form onSubmit={submit} data-testid="activation-form" className="mt-10 p-6 bg-[#F9FAFB] border border-gray-200 rounded-xl space-y-4">
          <Field label="Código de activación *" mono value={form.code} onChange={(v) => setForm({ ...form, code: v.toUpperCase() })} testid="activation-code-input" required placeholder="KAP-XXXX-YYYY" />
          <Field label="Nombre completo *" value={form.full_name} onChange={(v) => setForm({ ...form, full_name: v })} testid="activation-name" required />
          <Field label="Correo *" type="email" value={form.email} onChange={(v) => setForm({ ...form, email: v })} testid="activation-email" required />
          <Field label="Contraseña (mín 8) *" type="password" value={form.password} onChange={(v) => setForm({ ...form, password: v })} testid="activation-password" required minLength={8} />
          <button type="submit" disabled={submitting} data-testid="activation-submit-btn"
            className="w-full py-3 rounded-md bg-[#F26A21] hover:bg-[#D9541A] text-[#0B0B0B] font-semibold disabled:opacity-60">
            {submitting ? "Activando..." : "Activar y entrar"}
          </button>
        </form>
      </section>
    </PublicLayout>
  );
}

function Field({ label, value, onChange, type = "text", required, mono, testid, placeholder, minLength }) {
  return (
    <div>
      <label className="text-[11px] uppercase tracking-widest text-gray-600 font-semibold">{label}</label>
      <input data-testid={testid} required={required} type={type} value={value} placeholder={placeholder}
        minLength={minLength}
        onChange={(e) => onChange(e.target.value)}
        className={`w-full mt-1 bg-white border border-gray-200 rounded-md px-3 py-2 text-sm text-[#0B0B0B] focus:outline-none focus:border-[#F26A21] ${mono ? "font-mono tracking-widest text-center text-lg" : ""}`} />
    </div>
  );
}
